/**
 *   @description 接口请求拦截
 */
 import axios from 'axios'
 import router from "../router" // 路由
 import store from "../store"
 import Vue from "vue"
 import { whiteList } from "./config"
 import { MODE_CONF } from '@/utils/config'

const codeMessage = {
	200: '服务器成功返回请求的数据',
	201: '新建或修改数据成功',
	202: '一个请求已经进入后台排队（异步任务）',
	204: '删除数据成功',
	400: '发出的请求有错误，服务器没有进行新建或修改数据的操作',
	401: '用户没有权限（令牌、用户名、密码错误）',
	403: '用户得到授权，但是访问是被禁止的',
	404: '发出的请求针对的是不存在的记录，服务器没有进行操作',
	406: '最多允许导出3个月的数据，请重试！',
	// 406: '请求的格式不可得',
	410: '请求的资源被永久删除，且不会再得到的',
	422: '当创建一个对象时，发生一个验证错误',
	500: '服务器发生错误，请联系管理员',
	502: '网关错误',
	503: '服务不可用，服务器暂时过载或维护',
	504: '网关超时',
}

const serviceCreator = ({baseURL, headers={}})=>{

let domain = '';
if (window.location.host.split('.')[0] == 'www') {
	//localStorage.setItem('userPath', window.location.host.split('.')[1])
	domain = window.location.host.split('.')[1];
} else {
	//localStorage.setItem('userPath', window.location.host.split('.')[0])
	domain = window.location.host.split('.')[0];
}

// 创建一个axios实例
const service = axios.create({
	baseURL, 
	timeout: 30000, // 请求超时时间 默认30秒
	headers: {
		'Content-Type': 'application/json;charset=UTF-8',
		'X-company-domain': domain, //'qwO9gg5',
    ...headers
		// 'X-company': companyCode
	}
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		const token = localStorage.getItem('userToken')
		// 判断是否存在token，如果存在的话，则每个http header都加上token
		if (token) {
			config.headers['token'] = token
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data
		// 对响应数据做处理
		if (res.code === 6) {
			if (!whiteList.includes(router.history.current.path)) {
				Vue.prototype.$message({
					message: '登录已过期，请重新登录！',
					type: 'error'
				})
				logout()
			}
		} else {
			return res
		}
	},
	error => {
		if (error.response) {
			const res = error.response
			if (res.status === 401) {
				logout()
			} else if (res.data.code === 400001) {
				return Promise.reject(error.response)
			} else {
				if (res.data && res.data.reasonPhrase) {
					Vue.prototype.$message({
						message: res.data.msg,
						type: 'error'
					})
				}if(res.data){
          Vue.prototype.$message({
						message: res.data.msg|| codeMessage[res.status],
						type: 'error'
					})
        } else {
          console.log(res.data.msg)
					Vue.prototype.$message({
						message: codeMessage[res.status],
						type: 'error'
					})
				}

			}
		}
		return Promise.reject(error)
	}
)

return service
}
async function logout () {
	// 	await store.dispatch("user/logout");
	// 	router.push({
	// 		name: 'home',
	// 	});
}


const serviceApi = serviceCreator({
  baseURL: MODE_CONF.base_url
})

export default serviceApi

export const agentApi = serviceCreator({
  baseURL: MODE_CONF.base_url_agent
})

export const baseApi = serviceCreator({
  baseURL: MODE_CONF.base_code
})